import React from 'react';
import { useTrendingSearchesQuery } from 'src/gqlReactTypings.generated.d';
import { Container, Header, Results } from './styles';
import { TrendingSearchResult } from './TrendingSearchResult';

export interface TrendingSearchesProps {
  onClickTrend?: (searchTerm: string) => void;
  zipCode: string;
}

export const TrendingSearches: React.FC<TrendingSearchesProps> = ({ onClickTrend, zipCode }) => {
  const { data, loading, error } = useTrendingSearchesQuery({
    variables: { zipCode },
    fetchPolicy: 'cache-first',
  });

  if (error || loading || !data) {
    return null;
  }

  return (
    <Container>
      <Header>Trending searches</Header>
      <Results>
        {data.getTrendingSearches.map((searchTerm, idx) => (
          <TrendingSearchResult key={idx} searchTerm={searchTerm} onClick={onClickTrend} />
        ))}
      </Results>
    </Container>
  );
};
